import { useMemo } from 'react';
import { setMatchedRoute } from '@atlassian/jira-platform-router-utils/src/common/utils/index.tsx';
import { useRouter } from '@atlassian/react-resource-router';

const MatchedRouteListener = () => {
	const [{ route, match }] = useRouter();
	useMemo(() => setMatchedRoute(route, match), [route, match]);
	return null;
};

export { MatchedRouteListener };
